import { render } from "./DiagnosisDualBatteryTest.vue?vue&type=template&id=8ea05336"
import script from "./DiagnosisDualBatteryTest.vue?vue&type=script&lang=js"
export * from "./DiagnosisDualBatteryTest.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__